import { Component } from 'react';
import SVG from '.';
import { SVGIconPasswordEyeProps } from './SVGIconPasswordEye';

type SVGIconEyeOpenProps = SVGIconPasswordEyeProps;

export class SVGIconEyeOpen extends Component<SVGIconEyeOpenProps> {
  render() {
    const {
      width = 40,
      height = 40,
      className = '',
      fill = '#11465D',
      ...rest
    } = this.props;
    return (
      <SVG
        className={`svg-icon-eye-open ${className}`}
        width={`${width}px`}
        height={`${height}px`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
          fill={fill}
          transform="scale(1.67)"
        />
      </SVG>
    );
  }
}
